export default {
    product: {
        description: {
            more: "mehr"
        },
        added: "Zum Warenkorb hinzugefügt"
    }
}